import React from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../../store/configureStore";
import Bill from "./common/Bill";
import { history } from "../../../reducers";
import Loader from "../../common/Loader";
import { get_orgunit_details } from "../../../actions/action-orgunit";
import { get_purchase_return_details } from "./actions/action-purchaseReturn";
import NewBill from "./common/NewBill";


const store = configureStore();

function PurchaseReturnDetails() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { purchaseReturnDetails, showGlobalLoader } = useSelector(
    (state) => state.purchaseReturn
  );
  const { OrgunitDetails } = useSelector((state) => state.orgunit);

  useEffect(() => {
    let purchaseReturnId = window.location.pathname.split("/");
    purchaseReturnId = purchaseReturnId[3];
    console.log("purchaseReturnId", purchaseReturnId);

    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_purchase_return_details(purchaseReturnId, activeOuid));
      await dispatch(get_orgunit_details(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Purchase Return Details" />
      <div className="AppPage container--narrow mt FBAppPage">
        <button
          className="bill_edit_btn mb"
          onClick={() =>
            history.push(
              `/${activeOuid}/edit-purchase-return/${purchaseReturnDetails.id}`
            )
          }
        >
          Edit
        </button>
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <>
            <NewBill
              billDetails={purchaseReturnDetails}
              companyDetails={OrgunitDetails}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default PurchaseReturnDetails;
